import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Switch } from '~/components/ui/switch';
import { useSensitiveRevealStore } from '~/store/sensitive-reveal.store';

/**
 * "Reveal sensitive data" switch for the run inspector. Flips the session-wide
 * `useSensitiveRevealStore` flag (sessionStorage), so every inspector panel —
 * and every other inspector opened this session — un-masks / re-masks at once.
 * Server-side `[REDACTED]` secrets stay redacted either way.
 */
export function SensitiveRevealToggle() {
  const { t } = useTranslation('workflow-inspection');
  const reveal = useSensitiveRevealStore((s) => s.revealSensitive);
  const setReveal = useSensitiveRevealStore((s) => s.setRevealSensitive);

  return (
    <label
      className="bg-background text-foreground flex w-fit cursor-pointer items-center gap-2 rounded-lg border px-3 py-1.5 text-sm"
      title={t('reveal.hint')}
      data-testid="workflow-inspector-reveal-sensitive"
    >
      {reveal ? (
        <Eye aria-hidden="true" className="text-warning size-4 shrink-0" />
      ) : (
        <EyeOff aria-hidden="true" className="text-muted-foreground size-4 shrink-0" />
      )}
      <span>{t('reveal.label')}</span>
      <Switch
        checked={reveal}
        onCheckedChange={setReveal}
        className="cursor-pointer"
        data-testid="workflow-inspector-reveal-sensitive-toggle"
      />
    </label>
  );
}
